// Query keys live here (not in each hook file) so that mutation services in
// ~/services can import them without pulling in the hook modules, which would
// create a services → hooks → services cycle via fulfillmentContextService.
export const DOCK_LANES_QUERY_KEY = 'dock-lanes';
export const DOCK_LANE_QUERY_KEY = 'dock-lane';
export const DOCK_LANE_SCHEDULE_QUERY_KEY = 'dock-lane-schedule';
export const DOCK_LANE_SORT_CONFIGURATIONS_QUERY_KEY = 'dock-lane-sort-configurations';
export const DOCK_LANE_POSTAL_CODE_MAPPINGS_QUERY_KEY = 'dock-lane-postal-code-mappings';
export const DOCK_LANE_LIMITS_QUERY_KEY = 'dock-lane-limits';
export const ALL_PARTNER_LIMITS_QUERY_KEY = 'all-partner-limits';
export const DOCK_LANE_SHIPMENT_COUNTS_QUERY_KEY = 'dock-lane-shipment-counts';
